module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo16-ac74a3c6ec9fd24d994d54df2582e7f9.jpg";